/** Códigos internos POS (< 8 dígitos) — carnicería / verdulería sin balanza. */

export const CATEGORIA_PESO_VALORES = ['carne', 'verdura', 'fruta', 'fiambre', 'granel'];

export const CATEGORIA_PESO_LABELS = {
  carne: 'Carne',
  verdura: 'Verdura',
  fruta: 'Fruta',
  fiambre: 'Fiambre',
  granel: 'Granel'
};

/** Presets sugeridos al crear / escanear código interno */
export const CODIGOS_INTERNOS_PRESETS = {
  '1001': { nombre: 'Carne Molida', categoriaPeso: 'carne', precioPorKg: 6500, tipoVenta: 'peso_manual' },
  '1002': { nombre: 'Nalga', categoriaPeso: 'carne', precioPorKg: 8500, tipoVenta: 'peso_manual' },
  '1003': { nombre: 'Vacío', categoriaPeso: 'carne', precioPorKg: 9200, tipoVenta: 'peso_manual' },
  '1004': { nombre: 'Bife Ancho', categoriaPeso: 'carne', precioPorKg: 11000, tipoVenta: 'peso_manual' },
  '2001': { nombre: 'Papa', categoriaPeso: 'verdura', precioPorKg: 1200, tipoVenta: 'peso_manual' },
  '2002': { nombre: 'Tomate', categoriaPeso: 'verdura', precioPorKg: 2500, tipoVenta: 'peso_manual' },
  '2003': { nombre: 'Banana', categoriaPeso: 'fruta', precioPorKg: 1800, tipoVenta: 'peso_manual' },
  '3001': { nombre: 'Jamón Cocido', categoriaPeso: 'fiambre', precioPorKg: 7500, tipoVenta: 'peso_manual' },
  '3002': { nombre: 'Queso Cremoso', categoriaPeso: 'fiambre', precioPorKg: 6800, tipoVenta: 'peso_manual' }
};

export function normalizeCodigoBusqueda(raw) {
  return String(raw || '').trim();
}

/** EAN/GTIN típico: 8–14 dígitos */
export function isCodigoEanBusqueda(codigo) {
  const d = normalizeCodigoBusqueda(codigo).replace(/\D/g, '');
  return d.length >= 8 && d.length <= 14;
}

/** Código interno de mostrador: 1–7 dígitos puros (sin letras; PROD202 no es interno). */
export function isCodigoInterno(codigo) {
  const t = normalizeCodigoBusqueda(codigo);
  if (!t) return false;
  return /^\d{1,7}$/.test(t);
}

export function getPresetCodigoInterno(codigo) {
  const d = normalizeCodigoBusqueda(codigo).replace(/\D/g, '');
  return CODIGOS_INTERNOS_PRESETS[d] || null;
}

export function classifyCodigoEscaneado(raw) {
  const code = normalizeCodigoBusqueda(raw);
  if (!code) return 'vacio';
  const balanza = code.replace(/\D/g, '').length === 13;
  if (balanza && parseInt(code.replace(/\D/g, '').slice(0, 2), 10) >= 20) {
    return 'balanza';
  }
  if (isCodigoInterno(code)) return 'interno';
  if (isCodigoEanBusqueda(code)) return 'ean';
  return 'otro';
}
